module.exports = __webpack_public_path__ + "static/img/wealth_level_100.ced2448.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/wealth_level_100.png
// module id = LfYP
// module chunks = 0